export const formatMoney = (amount, { withCurrency = true } = {}) => {
  const options = {
    style: withCurrency ? "currency" : "decimal",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  };

  const formatter = new Intl.NumberFormat("id-ID", options);
  return formatter.format(amount);
};

// Blank/non-numeric input renders as an empty string rather than "NaN", which
// matches how MUI's built-in numeric column treats a missing value.
export const formatNumber = (amount) => {
  if (amount === null || amount === undefined || amount === "") return "";

  const value = Number(amount);
  if (Number.isNaN(value)) return "";

  return new Intl.NumberFormat("id-ID").format(value);
};

// Money shown as a deduction (leading minus), but never a signed zero:
// 120000 -> "-Rp 120.000", 0 -> "Rp 0".
export const formatDeduction = (amount) =>
  amount > 0 ? `-${formatMoney(amount)}` : formatMoney(amount);

export const formatDateTime = (date) => {
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };

  const formatter = new Intl.DateTimeFormat("id-ID", options);
  return formatter.format(new Date(date));
};

export const formatDate = (date) => {
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const formatter = new Intl.DateTimeFormat("id-ID", options);
  return formatter.format(new Date(date));
};

export const getShortReference = (referenceNumber) => {
  if (!referenceNumber) return "";
  const parts = referenceNumber.split("-");
  return parts[parts.length - 1];
};
